// Interface
import { IForwardMessageRecipient } from '../interfaces/forwardmessage.interfaces';
// Enums
import { RecipientIdType } from '../enums';

export const listIncludesNonSecureRecipient = (forwardMessageRecipientList: IForwardMessageRecipient[]): boolean =>
    forwardMessageRecipientList.some((recipient) => recipient.idType === RecipientIdType.EMAIL);
